import { render, staticRenderFns } from "./MyInfomation.vue?vue&type=template&id=94dd63aa&scoped=true&"
import script from "./MyInfomation.vue?vue&type=script&lang=js&"
export * from "./MyInfomation.vue?vue&type=script&lang=js&"
import style0 from "./MyInfomation.vue?vue&type=style&index=0&id=94dd63aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dd63aa",
  null
  
)

export default component.exports